<ng-container *ngIf="googleMapsApiLoaded">
  <ng-container *transloco="let tr; prefix: 'deliveryZones'; scope: 'delivery-zones'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.url')}}</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="prop.url" (ngModelChange)="notify()"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.defaultMapType')}}</nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="prop.defaultMapType" nzShowSearch nzAllowClear nzPlaceHolder="Выберите тип"
                       [nzDropdownMatchSelectWidth]="false" (ngModelChange)="changeDefaultType()">
              <nz-option [nzValue]="'none'"
                         [nzLabel]="'enum.GisType.none' | transloco"></nz-option>
              <nz-option *ngFor="let op of gisTypeOptions" [nzValue]="op.value"
                         [nzLabel]="op.key | transloco"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-2" *ngIf="prop.defaultMapType">
        <nz-form-item>
          <nz-form-label>{{tr('property.form.additionalMapType')}}</nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="prop.mapTypes" nzShowSearch nzAllowClear nzMode="multiple"
                       nzPlaceHolder="Выберите тип" [nzDropdownMatchSelectWidth]="false"
                       (ngModelChange)="changeAdditionalType()">
              <nz-option *ngFor="let op of addGisTypeOptions" [nzValue]="op.value"
                         [nzLabel]="op.key | transloco"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item *ngIf="prop.defaultMapType === 'dgis' || (prop.mapTypes && prop.mapTypes.includes('dgis'))">
          <nz-form-label nzRequired>{{tr('property.form.dgisRegionId')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number [(ngModel)]="prop.dgisRegionId" (ngModelChange)="notify()"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-2">
        <nz-form-item
          *ngIf="prop.defaultMapType === 'yandex' || (prop.mapTypes && prop.mapTypes.includes('yandex'))">
          <nz-form-label [nzTooltipTitle]="tr('yandex.bbox.description')"
                         nzRequired>{{tr('property.form.yandexSearchRegion')}}</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="prop.bbox" (ngModelChange)="notify()"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item
          *ngIf="prop.defaultMapType === 'google' || (prop.mapTypes && prop.mapTypes.includes('google'))">
          <nz-form-label [nzTooltipTitle]="tr('google.bounds.description')"
                         nzRequired>{{tr('property.form.googleSearchRegion')}}</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="prop.bounds" (ngModelChange)="notify()"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.geoJSON')}}</nz-form-label>
          <nz-form-control>
            <textarea rows="4" nz-input [(ngModel)]="geoJSON" (ngModelChange)="onGeoJSONChange()"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <ng-container *ngIf="prop.center">
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('property.form.cityLat')}}</nz-form-label>
            <nz-form-control>
              <nz-input-number [(ngModel)]="prop.center.lat" (ngModelChange)="notify()"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('property.form.cityLng')}}</nz-form-label>
            <nz-form-control>
              <nz-input-number [(ngModel)]="prop.center.lng" (ngModelChange)="notify()"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{tr('property.form.includeAdmDiv')}}</nz-form-label>
            <nz-form-control>
              <nz-switch [(ngModel)]="prop.includeAdmDiv" (ngModelChange)="notify()"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row *ngIf="prop.center.lat && prop.center.lng">
        <div nz-col class="hx-col-4">
          <google-map [width]="'100%'" [zoom]="12" [center]="{lng: prop.center.lng, lat: prop.center.lat}">
            <map-polygon *ngFor="let dp of deliveryPolygons"
                         [options]="dp.options"
                         (polygonClick)="onPolygonClicked(dp)"
                         [paths]="dp.vertices"></map-polygon>
          </google-map>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>


